import React from "react";
import { TableCell, TableRow, TableCellProps } from "@material-ui/core";
import { Skeleton } from "@material-ui/lab";

const LoadingCell: React.FC<TableCellProps> = ({ ...props }) => (
  <TableCell {...props}>
    <Skeleton variant="text" component="span" animation="wave" />
  </TableCell>
);

export const LoadingRow: React.FC<{
  col: number;
}> = ({ col }) => {
  return (
    <>
      {Array.from({ length: 3 }, (_, i) => (
        <TableRow data-testid="LoadingRow" key={i}>
          {Array.from({ length: col }, (_, j) => (
            <LoadingCell key={j} />
          ))}
        </TableRow>
      ))}
    </>
  );
};
